import { z } from 'zod';

import { SAP_ARCHITECTURES } from '../../create-agent.utils';

const baseAgentFields = {
  name: z
    .string()
    .min(1, 'Agent name is required.')
    .max(255, 'Agent name must be under 255 characters.')
    .regex(/^[-A-Za-z0-9_. ]+$/, 'Only letters, numbers, hyphens, underscores, dots, and spaces are allowed.'),

  agentHost: z
    .string()
    .min(1, 'Agent host IP address or hostname is required.')
    .max(50, 'Agent host must be between 1 and 50 characters.'),

  description: z.string().max(255, 'Description cannot exceed 255 characters.').optional().or(z.literal('')),
};

export const opAgentDetailsSchema = z.object({
  ...baseAgentFields,
});

export const standaloneAgentDetailsSchema = z.object({
  ...baseAgentFields,
  architecture: z.enum(SAP_ARCHITECTURES, {
    message: 'Please select an architecture type.',
  }),
});

export type OpAgentDetailsFormValues = z.infer<typeof opAgentDetailsSchema>;
export type StandaloneAgentDetailsFormValues = z.infer<typeof standaloneAgentDetailsSchema>;
export type AgentDetailsFormValues = OpAgentDetailsFormValues | StandaloneAgentDetailsFormValues;

export const STANDALONE_AGENT_DETAILS_DEFAULTS: StandaloneAgentDetailsFormValues = {
  name: '',
  architecture: SAP_ARCHITECTURES[0],
  agentHost: '',
  description: '',
};

export const OP_AGENT_DETAILS_DEFAULTS: OpAgentDetailsFormValues = {
  name: '',
  agentHost: '',
  description: '',
};
